module.exports = __webpack_public_path__ + "img/ticket.95a0a3bc.svg";